import { http, httpgst } from '../../main'
import { store } from '../../store'

const actions = {
  getLogged ({commit, dispatch}, payload) {
    let url = 'api/user-logged'
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    http.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    http.defaults.headers.common['X-device'] = 'WEB'
    http.get(url, {}, options)
      .then(
        response => {
          commit('onGetLogged', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  getExpenses ({commit, dispatch}, payload) {
    let url = 'api/expenses-dates/' + payload.event.start + '/' + payload.event.end + '/' + payload.event.id
    let params = {
      'category_id': payload.event.category_id !== null ? payload.event.category_id : undefined,
      'project_id': payload.event.project_id !== null ? payload.event.project_id : undefined,
      'status_id': payload.event.status_id !== null ? payload.event.status_id : undefined
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url, { params: params })
      .then(
        response => {
          commit('onGet', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  getExpensesItem ({commit, dispatch}, payload) {
    let url = 'api/expenses_items/' + payload.event.id
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {}, options)
      .then(
        response => {
          commit('onGetExpenseItem', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  }
}

const mutations = {
  onGetLogged (state, payload) {
    let userLogged = payload.response.data.data
    payload.event.context.userLogged = userLogged
  },
  onGet (state, payload) {
    let expenses = payload.response.data.data

    if (expenses) {
      expenses.forEach((expense) => {
        if (expense.has_multiprojects === 1 && expense.items && expense.items.length > 0) {
          const processed = {}
          expense.items.sort((a, b) => a.project_id - b.project_id)
          expense.items.forEach((item) => {
            item.has_multiprojects = true
            item.titleName = item.project_id ? expense.multiprojects.find(x => x.id === item.project_id).name : ''
            if (item.project_id && !processed[item.project_id]) {
              item.isTitle = true
              processed[item.project_id] = true
            } else {
              item.isTitle = false
            }
          })
        }
      })
    }

    payload.event.context.expenses = expenses
    // payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.close()
    payload.event.context.loadingItems = false
  },
  onGetExpenseItem (state, payload) {
    let item = payload.response.data.data
    payload.event.context.expenseItem = item
    payload.event.context.itemDialog = true
    payload.event.context.loading = false
    payload.event.context.showExpenseItemFile()
  },
  onError (state, payload) {
    if (payload.error.response.data.errors !== undefined) {
      payload.event.context.errors = payload.error.response.data.errors
    }

    if (payload.error.response.status === 401) {
      payload.event.context.showNotification(payload.event.context.$t('login.sessionExpired'), 'error', -1)
      setTimeout(() => { payload.event.context.$router.push({ name: 'LoginPage' }) }, 2000)
    }

    // payload.event.context.showNotification(payload.error.response, 'error', -1)
    payload.event.context.loading = false
    payload.event.context.loadingItems = false
  }
}

export default {
  namespaced: true,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/history.js